import { Routes } from '@angular/router';

import appShellRoutes from '@stair-craft/shell';

export const appRoutes: Routes = appShellRoutes;
